import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";
import T from "@/lib/testIds";

/**
 * variant:
 *   "default"    - white glass (admin, grid header)
 *   "onDark"     - transparent w/ white text (feed header over dark gradient)
 *   "onLight"    - lilac accent (grid header)
 */
export default function ThemeToggle({ variant = "default" }) {
  const { theme, toggle } = useTheme();
  const cls = {
    default: "text-plum dark:text-cream",
    onDark: "text-white",
    onLight: "text-plum",
  }[variant];
  return (
    <button
      onClick={toggle}
      data-testid={T.themeToggle}
      aria-label={theme === "dark" ? "Ganti ke mode terang" : "Ganti ke mode gelap"}
      className={`grid h-full w-full place-items-center active:scale-90 transition-transform ${cls}`}
    >
      {theme === "dark" ? <Sun className="h-4 w-4" strokeWidth={2} /> : <Moon className="h-4 w-4" strokeWidth={2} />}
    </button>
  );
}
